// extracted by mini-css-extract-plugin
export default {"option":"OptionSelect_option__85NP8","desabilitar":"OptionSelect_desabilitar__Sv5Gl","focado":"OptionSelect_focado__aDCEl","novo":"OptionSelect_novo__sqN0v"};